'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _layout = require('./layout');

var _layout2 = _interopRequireDefault(_layout);

var _Sider = require('./Sider');

var _Sider2 = _interopRequireDefault(_Sider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_layout2['default'].Sider = _Sider2['default'];
exports['default'] = _layout2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/layout/index.js
// module id = 726
// module chunks = 0